import React from "react";
import { useDispatch } from "react-redux";
import { AppThunkDispatch } from "@/store";
import actionsHandler from "@/store/actions/actionHandler";
import { toast } from "react-toastify";
import { useParams } from "react-router-dom";
import SimpleDynamicForm from "@/components/common/SimpleDynamicForm";
import { InputFieldType } from "@/constants/enums/input-field-type.enum";
import * as Yup from "yup";
import { DynamicFormField } from "@/models/dynamic-form.model";

interface SopDetails {
  display: number;
  input_type: {
    type: number;
    field: string;
  } | null;
  text: string;
}
export interface SopData {
  data: SopDetails[];
  note: string | null;
}

interface DisplaySopDetailsProps {
  title?: string;
  items?: SopData;
  user_id?: string;
  id?: string;
  isFinOb1?: boolean;
  onSave?: () => void;
  initialValues?: any;
  readOnly?: boolean;
}

const DisplaySopDetails: React.FC<DisplaySopDetailsProps> = ({
  title = "SOP",
  items = { data: [], note: null },
  isFinOb1,
  onSave,
  initialValues,
  readOnly,
}) => {
  const { id } = useParams();
  const dispatch = useDispatch<AppThunkDispatch>();

  const generateFormFields = (): DynamicFormField[] => {
    const formFields: DynamicFormField[] = [];

    items.data.forEach((item, index) => {
      if (typeof item === "string") {
        formFields.push({
          name: item,
          label: item,
          type: InputFieldType.BULLET_LIST,
        });
      } else {
        if (item.input_type === null) {
          formFields.push({
            name: item.text,
            label: item.text,
            type:
              item.display === 1
                ? InputFieldType.BULLET_LIST
                : InputFieldType.NORMAL_TEXT,
          });
        } else {
          if (item.input_type?.type === 1) {
            formFields.push({
              name: item.input_type.field,
              label: item.text,
              type: InputFieldType.TEXTAREA,
              required: true,
              validation: Yup.string().required("This field is required"),
              defaultValue: "",
            });
          } else if (item.input_type?.type === 2) {
            formFields.push({
              name: item.input_type.field,
              label: item.text,
              type: InputFieldType.CHECKBOX,
              required: true,
              validation: Yup.boolean(),
              defaultValue: false,
            });
          }
        }
      }
    });

    return formFields;
  };

  const formFields = React.useMemo(() => generateFormFields(), [items.data]);

  const handleSubmit = async (values: any) => {
    try {
      const { authenticatedCall } = actionsHandler(
        "updateOnboardingDocumentInputFields",
      );

      console.log("values: ", values);

      const response = await dispatch(
        authenticatedCall({
          method: "post",
          payload: values,
          customParams: !isFinOb1 ? [`${id}/`] : undefined,
        }),
      );

      if (response.ok) {
        toast.success(response.data.message);
        onSave?.();
      }
    } catch (error) {
      console.error("Error updating fields:", error);
    }
  };

  return (
    <div className="tw-bg-[#ffffff] tw-rounded-2xl tw-shadow-md tw-border tw-border-[#E9EAEB] tw-w-full">
      <div className="tw-px-6 tw-py-4">
        <span className="tw-text-[#232323] tw-text-base tw-font-semibold">
          {title}
        </span>
      </div>
      <hr className="tw-border-[#E9EAEB]" />
      <div className="tw-px-6 tw-py-4">
        <SimpleDynamicForm
          fields={formFields}
          onSubmit={handleSubmit}
          readOnly={readOnly}
          submitButtonText="Save"
          initialValues={initialValues || {}}
        />

        {items?.note && (
          <div className="tw-mt-2 tw-text-[#232323] tw-text-sm">
            <ul className="tw-list-disc tw-pl-5">
              <li>
                Note:
                <span className="tw-text-gray-400 tw-font-medium tw-text-sm tw-ml-1">
                  "{items.note}"
                </span>
              </li>
            </ul>
          </div>
        )}
      </div>
    </div>
  );
};

export default DisplaySopDetails;
